import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ImpactSection } from "@/components/sections/ImpactSection";
import { CTASection } from "@/components/sections/CTASection";

const Impact = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <ImpactSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Impact;
